export default __webpack_public_path__ + "static/media/protiv-logo-icon.9c471e44.svg";